import Lowercase from './string.filters/lowercase.filter'
import Uppercase from './string.filters/uppercase.filter'
import TimeStamp from './date.filters/timestamp.filter'
export default {
  install (Vue) {
    Vue.filter('uppercase', Uppercase)
    Vue.filter('lowercase', Lowercase)
    Vue.filter('timestamp', TimeStamp)
  }
}



// WEBPACK FOOTER //
// ./src/filters/index.js